import React from 'react';
import { formatCurrency } from '../../utils/currencyUtils';
import SettleFromWalletModal from '../shared/SettleFromWalletModal';
import { MODAL_SECTIONS } from '../shared/modalTheme';

export default function SettleLabourWalletModal({
  payment,
  employees,
  companyCurrency,
  settleDate,
  setSettleDate,
  settlePaymentMode,
  setSettlePaymentMode,
  settleEmployeeId,
  setSettleEmployeeId,
  settleEmployeeBalance,
  settleRemark,
  setSettleRemark,
  submitting,
  onClose,
  onSubmit,
}) {
  if (!payment) return null;

  const personLabel =
    payment.personType === 'Employee'
      ? employees.find((e) => e.employeeId === payment.employeeId)?.name || payment.employeeId
      : payment.personName || '—';

  return (
    <SettleFromWalletModal
      open
      modalSection={MODAL_SECTIONS.LABOUR}
      summaryPrimary={`${payment.paymentType} · ${formatCurrency(Number(payment.amount), companyCurrency)}`}
      summarySecondary={`${personLabel} · ${payment.date}`}
      amount={payment.amount}
      employees={employees}
      companyCurrency={companyCurrency}
      settleDate={settleDate}
      setSettleDate={setSettleDate}
      settlePaymentMode={settlePaymentMode}
      setSettlePaymentMode={setSettlePaymentMode}
      settleEmployeeId={settleEmployeeId}
      setSettleEmployeeId={setSettleEmployeeId}
      settleEmployeeBalance={settleEmployeeBalance}
      settleRemark={settleRemark}
      setSettleRemark={setSettleRemark}
      submitting={submitting}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
}
